// Central business config used across the site
export const SITE = {
  name: "Vic Wide Cheap Towing Service",
  short: "Vic Wide Towing",
  tagline: "Cheap & Reliable 24/7 Towing Across Victoria",
  subtagline: "Starting from just $70 — fast response when you need it most.",
  phones: [
    { label: "Primary", number: "0431 349 572", tel: "0431349572" },
    { label: "Secondary", number: "0413 877 508", tel: "0413877508" },
  ],
  email: "Robertbichel290@gmail.com",
  rating: 4.5,
  reviewsCount: 19,
  pricingFrom: 70,
  availability: "Open 24 hours · 7 days a week",
  locations: [
    { city: "Sale", region: "Victoria, Australia", address: "Sale, VIC" },
    { city: "Albion", region: "Victoria, Australia", address: "31 King Edward Ave, Albion VIC 3020" },
  ],
  mapEmbeds: {
    sale: "https://www.google.com/maps?q=Sale,+Victoria,+Australia&output=embed",
    albion: "https://www.google.com/maps?q=31+King+Edward+Ave,+Albion+VIC+3020&output=embed",
  },
  serviceArea: [
    "Melbourne", "Sale", "Albion", "Geelong", "Ballarat", "Bendigo",
    "Traralgon", "Warragul", "Pakenham", "Frankston", "Werribee",
    "Sunbury", "Gippsland", "Mornington Peninsula",
  ],
};

export const PRIMARY_PHONE = SITE.phones[0];
